module.exports = __webpack_public_path__ + "032dd4e49c2a72102e9537438cbf6100.svg";